/// <reference types="vite-plugin-svgr/client" />

import type { MutableRefObject } from 'react'

import type { UserData } from '@/__generated__/requests'

import TrashIcon from '@/assets/icons/trash.svg?react'
import UploadIcon from '@/assets/icons/upload.svg?react'

export const useChangeAvatarMenuItems = (
  avatar: UserData['avatar'],
  setAvatar: (avatar: UserData['avatar']) => void,
  fileInputRef: MutableRefObject<HTMLButtonElement | null>,
) => {
  const items = [
    {
      icon: UploadIcon,
      label: 'Upload image',
      onClick: () => {
        if (fileInputRef.current) {
          fileInputRef.current.click()
        }
      },
      to: '',
    },
  ]

  if (avatar) {
    items.push({
      icon: TrashIcon,
      label: 'Remove image',
      onClick: () => setAvatar(null),
      to: '',
    })
  }

  return items
}
